import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InboxIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Inbox",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.86 17.35 25.1 5.54c-.28-.69-.94-1.16-1.72-1.16H8.59c-.77 0-1.44.48-1.71 1.15L2.13 17.32c-.09.2-.13.44-.14.69v7.77c0 1.02.82 1.84 1.84 1.85h24.31c1.02 0 1.85-.83 1.85-1.85v-7.75c0-.25-.05-.48-.14-.69Zm-20-9.26h12.28l3.26 8.11h-3.47c-.77 0-1.43.47-1.71 1.14s-1.07 2.63-1.07 2.63h-6.31l-1.07-2.61c-.28-.68-.94-1.15-1.71-1.15H6.59L9.85 8.1Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 29.3H5.29c-1.89 0-3.43-1.54-3.43-3.43V15.58c0-.63.51-1.14 1.14-1.14h8c.63 0 1.14.51 1.14 1.14v2.29H19v-2.29c0-.63.51-1.14 1.14-1.14h8c.63 0 1.14.51 1.14 1.14v10.29c0 1.89-1.54 3.43-3.43 3.43ZM4.14 16.73v9.14c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14v-9.14h-5.71v2.29c0 .63-.51 1.14-1.14 1.14H11c-.63 0-1.14-.51-1.14-1.14v-2.29H4.15Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 16.73c-.5 0-.97-.34-1.1-.85L23.89 4.14H7.24l-2 7.2c-.17.61-.8.96-1.41.8-.61-.17-.96-.8-.8-1.41l2.24-8.04c.14-.5.59-.84 1.1-.84h18.4c.52 0 .97.35 1.1.85l3.37 12.59a1.145 1.145 0 0 1-1.11 1.44Z"
      })]
    })
  }));
};
InboxIcon.displayName = 'InboxIcon';